var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberLinkX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    fill: "#979797",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2898 14.4369L22.7724 8H21.4737L16.7111 13.5879L12.9101 8H8.52499L14.2741 16.4507L8.52499 23.2H9.82374L14.8499 17.2977L18.8649 23.2H23.25M10.2925 8.9892H12.2877L21.4727 22.2594H19.477",
    fill: "#EEEEEE",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberLinkX);
export default __webpack_public_path__ + "static/media/member-link-x.b193fd504bc5feadd8f389aab9992599.svg";
export { ForwardRef as ReactComponent };